import React from "react";
import CookieBanner from "../molecules/CookieBanner";
import Footer from "../organisms/Footer";
import Header from "../organisms/Header";
export function Frame(props) {
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Header, {
        mainNavigation: props.mainNavigation,
        metaNavigation: props.metaNavigation
    }), props.children, /*#__PURE__*/ React.createElement(Footer, {
        footerNavigation: props.footerNavigation,
        legalNavigation: props.legalNavigation
    }), /*#__PURE__*/ React.createElement(CookieBanner, null));
}
